import { navigateToUrl } from 'single-spa';
import store from 'store';
import { takeLatest, put, call } from 'redux-saga/effects';

import { postVerifyEmail } from '../../api/verifyEmail';
import { showLoadingSpinner } from '../moka/actions';
import { isInvalidTokenVerifyEmail } from './actions';
import { SEND_VERIFY_EMAIL } from './types';

export function* verifyEmail(request) {
  // reset state
  yield put(isInvalidTokenVerifyEmail(false));
  yield put(showLoadingSpinner(true));
  try {
    const token = request.payload.access_token;
    const resVerifyEmail = yield call(postVerifyEmail, {
      access_token: token,
    });
    const user = resVerifyEmail.data;
    if (user) {
      // Persist user info in local storage
      store.set('response:login', user);

      if (user.is_owner || user.is_manager) {
        // owner or manager go to dashboard page
        navigateToUrl('/dashboard');
      } else {
        // staff go to account settings
        navigateToUrl('/settings/accounts');
      }
    }
  } catch (error) {
    yield put(isInvalidTokenVerifyEmail(true));
  } finally {
    yield put(showLoadingSpinner(false));
  }
}

export default function* verifyEmailSaga() {
  yield takeLatest(SEND_VERIFY_EMAIL, verifyEmail);
}
